<div class="heatmap" style="max-height: 320px;">
  @if (ready) {
    <ngx-charts-heat-map class="dark"
      [scheme]="colorScheme"
      [legend]="legend"
      [tooltipText]="tooltipText"
      [animations]="animations"
      [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel"
      [min]="min"
      [max]="max"
      [xAxis]="xAxis"
      [yAxis]="yAxis"
      [results]="chartData">
    </ngx-charts-heat-map>
  }
  @if (!ready) {
    <div class="d-flex justify-content-center align-items-center" style="height: 320px;">
      <app-loading-spinner></app-loading-spinner>
    </div>
  }
</div>

